import { render, staticRenderFns } from "./ProcedureTypeShow.vue?vue&type=template&id=1c551644&"
import script from "./ProcedureTypeShow.vue?vue&type=script&lang=js&"
export * from "./ProcedureTypeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports